import TextMetricController from '../../controllers/TextMetricController';
import NotificationController from '../../controllers/NotificationController';
import { COMPONENTS } from '../../lib/constants';
import MainGridController from '../../controllers/grid/MainGridController';
import { NotificationViewGrid } from './NotificationViewGrid';
// import { isDesktop } from "react-device-detect";
// let position = {
//   passiveBot: {
//     x: isDesktop ? -41 : -41,
//     y: isDesktop ? 242 : 242,
//   },
//   passiveTop: {
//     x: isDesktop ? -40 : -40,
//     y: isDesktop ? -42 : -42,
//   },
// };

// let mult = isDesktop ? 1 : 2;

export const NotificationView = {
	name: COMPONENTS.NOTIFICATION,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: TextMetricController,
			name: 'TextMetricController',
			config: {
				item: 'notif_bg',
				val: 'notif_bg',
				position: { x: 0, y: 0, w: 587 },
				texts: [
					{
						value: 'notif_desc',
						position: { x: 0, y: 267 / 2 },
						maxLineWidth: 2.4,
						wordWrap: true
					}
				]
			}
		},
		{
			Controller: NotificationController,
			name: 'NotificationController',
			config: {
				item: 'notif_bg',
				holder: 'notif_bg'
			}
		},
		{
			Controller: MainGridController,
			name: 'NotificationGridController',
			config: NotificationViewGrid
		}
	],
	components: [
		{
			name: 'notif_bg',
			type: 'Sprite',
			components: [
				{
					name: 'notif_bg',
					type: 'Sprite',
					img: 'notif_bg'
				},
				{
					name: 'notif_border',
					type: 'Sprite',
					img: 'notif_border',
					position: { x: -20, y: -18 }
				},
				{
					name: 'notif_title',
					type: 'Text',
					text: 'NOTIFICATION_HEADER',
					position: { x: 587 / 2, y: 40 }
				},
				{
					name: 'notif_desc',
					type: 'Text',
					text: 'NOTIFICATION_DESC',
					position: { x: 0, y: 267 / 2 }
				},
				{
					name: 'close',
					type: 'ActionButton',
					bg: 'dialog_yes_btn',
					position: { x: 587 / 2, y: 285 }
				}
			]
		}
	]
};
